<template>
  <div class="mb-5 flex justify-center">
    <img
      v-if="brokerLogo"
      class="mx-auto mt-8 hidden h-11 w-auto md:block"
      :src="brokerLogo"
      alt="broker logo"
    />
  </div>
  <layout>
    <img
      v-if="brokerLogo"
      class="mx-auto my-6 h-11 w-auto md:hidden"
      :src="brokerLogo"
      alt="broker logo"
    />
    <div>
      <div class="-mr-2 mb-1 flex items-center justify-between">
        <h1 class="self-start pt-3 text-left text-xl text-dark-gray">
          Access Request Pending...
        </h1>
        <img
          src="@/assets/highway-badge.svg"
          alt="highway icon"
        />
      </div>
      <section
        v-if="
          currentUser?.company_verification_status ==
          'locked_for_manual_approval'
        "
      >
        <p class="mb-5 text-left text-sm text-dark-gray">
          Looks like you belong to a really big carrier. We're so glad you're
          here, but we need to manually approve your access.
        </p>
        <p>
          Please reach out to
          <a
            class="text-xm mb-5 cursor-pointer text-yellow-500"
            href="mailto:service@highway.com"
          >
            service@highway.com
          </a>
          and be prepared to provide third-party verification information,
          including your driver's license, employee email address, and corporate
          authority.
        </p>
      </section>
      <section v-else-if="showCarrierSection">
        <p class="mb-1 text-left text-sm text-dark-gray">
          Your request has been emailed to the contact methods publicly
          registered with the FMCSA, if applicable, or to any users already
          belonging to this account.
        </p>
        <p class="my-5 text-left text-sm text-dark-gray">
          Please follow up with those authorized representatives of the carrier
          to get your request approved.
        </p>
        <p class="mb-5 text-left text-sm text-dark-gray">
          Once your request is approved, you will be notified by email.
        </p>
      </section>
      <section v-else>
        <p class="mb-5 text-left text-sm text-dark-gray">
          This carrier has already been onboarded, but your request to
          {{ carrierName }} has been sent. You can expect a response soon.
        </p>
        <p class="mb-5 text-left text-sm text-dark-gray">
          In the meantime, you can add more carriers in your Dispatch Service
          Portal.
        </p>
        <button-main
          class="mb-4"
          @click="handleSubmit"
        >
          Add More carriers
        </button-main>
      </section>
      <p
        v-if="
          currentUser?.company_verification_status !==
          'locked_for_manual_approval'
        "
        class="mb-5 mr-1 text-left text-gray-400"
      >
        For technical support, contact
        <a
          class="mb-5 cursor-pointer text-yellow-500"
          href="mailto:service@highway.com"
        >
          service@highway.com
        </a>
        .
      </p>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/layouts/HoldingTankLayout.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'AccessPending',
  components: {
    Layout,
    ButtonMain,
  },
  data() {
    return {
      company: {},
    };
  },
  computed: {
    carrierName() {
      return this.$store.state.carriers?.carrierDetails?.legal_name || '';
    },
    companyType() {
      return this.$store.state.users?.currentUser?.company?.company_type || '';
    },
    showCarrierSection() {
      return this.companyType !== 'dispatcher';
    },
    currentUser() {
      return this.$store.state.users.currentUser;
    },
    brokerLogo() {
      return this.$store.state.brokers?.logo?.url || null;
    },
  },
  async created() {
    const clientId = localStorage.getItem('client_id');
    await this.$store.dispatch('users/serverRefreshCurrentUser');
    await this.$store.dispatch('brokers/getLogoByClientId', clientId);
    let currentUser = this.$store.state.users.currentUser;
    // Redirect if the user is already associated with a company
    if (currentUser?.company?.id) {
      let redirectAfterSignIn = JSON.parse(
        localStorage.getItem('redirect_url_after_sigin')
      );

      // If they came in through the OAuth process,
      // then then they will be redirected to the /oauth/authorizations
      // endpoint with the correct credentials
      if (redirectAfterSignIn) {
        localStorage.removeItem('redirect_url_after_sigin');
        return this.$router.push(redirectAfterSignIn);
      } else {
        this.$router.push({ name: 'Home' });
      }
    }
  },
  methods: {
    handleSubmit() {
      // TODO - Related to a new product which is building.
    },
  },
};
</script>
